import { Component, Injectable, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService, NbMenuItem, NbDialogService, NbToastrService } from '@nebular/theme';

import { map, takeUntil, tap, switchMap, filter, isEmpty } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { UserService } from '../../../service/user.service';
import { DataNavigation } from '../../../util/dataNavigation';
import { AuthorizationService } from '../../../service/authorizationService';
import { Authorization } from '../../../model/authorization';
import { Router } from '@angular/router';
import { AuthRoles, AuthRoles_PT_EN, AuthRoles_PTBR } from '../../../model/AuthRoles';
import { ConfigurationService } from '../../../service/configuration.service';
import { AuthService } from '../../../service/auth.service';
import { PopupAdvertisementComponent } from '../../../dialog/popup-advertisement/popup-advertisement.component';
import { Essentials } from '../../../util/essentials';
import { MountMenu } from '../../../util/mountMenu';
import { TranslateService } from '@ngx-translate/core';
import { UserRoles } from '../../../model/userRoles';
import { VehicleSpeedEventService } from '../../../service/vehicle-speed-event.service';
import { Configuration } from '../../../model/configuration';
import { ConfKeys } from '../../../model/configurationKeys';
import { stringify } from 'querystring';
import { DatePipe } from '@angular/common';

enum statusCode {
  showPopup = 404,
  notShowPopup = 200,
  logout = 409,
  lackOfPayment = 402
}

@Injectable({
  providedIn: 'root',
})

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  enterpriseName: string = '';
  licensedUntil: Date;
  maxControllers: number;
  maxcontrollers
  userProfileSubscription: Subscription = undefined;

  statusCodeResponse: any;
  title: string = '';
  message: string = '';
  img: string = ''
  showImgAdvertisement: boolean;
  setInterval: any = 0;
  timerSetInterval: number = 60; //Valor em minutos
  setIntervalForCheckSpeeding: any;
  imgLogo: string;
  hasImgLogoThird: boolean = true;
  alertIsOpen: boolean;
  speedingEvents: any = [];
  eventsCount: number;
  configLastSpeedingEvent: boolean;


  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu: NbMenuItem[] = [
    { title: 'Sair', link: '/logout' },
  ];

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private router: Router,
    private userService: UserService,
    private dataNavigation: DataNavigation,
    private breakpointService: NbMediaBreakpointsService,
    private nbMenuService: NbMenuService,
    private authorizationService: AuthorizationService,
    private config: ConfigurationService,
    private dialogService: NbDialogService,
    private authService: AuthService,
    private essentials: Essentials,
    private toastrService: NbToastrService,
    private vehicleSpeedEventService: VehicleSpeedEventService,
    private datepipe: DatePipe,
    private translate: TranslateService) {
  }

  ngOnInit() {
    window.onbeforeunload = function () {
      console.log("Reload feito!")
    };

    this.imgLogo = localStorage.getItem('imgLogo') || '../../../assets/logo.png';
    this.enterpriseName = localStorage.getItem('enterpriseName') || '. . .';
    localStorage.setItem('habilitedAdvertisement', 'true')

    this.currentTheme = this.themeService.currentTheme;

    this.userProfileSubscription = this.nbMenuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'profile-menu'),
        map(item => item.item),
      )
      .subscribe(
        (item: NbMenuItem) => {
          // if there is more then one authorization, use the menu selected option to check wich one user wants
          // otherwise just get the authorization that he has stored (will be only one so array[0])
          if (item.title != "Sair" && item.title != "Perfis" && item.target != undefined) {
            let authorizationId = parseInt(item.target);
            this.authorizationService.getById(authorizationId, false)
              .subscribe((auth) => {
                this.dataNavigation.selectAuthorization(auth);
                this.router.navigate(["/pages/register"]);
              }, ((error) => {
                console.log(error.message)
              }));
          }
        }
      );

    this.authorizationService.getByUser(AuthService.getUserIdFromClaims())
      .subscribe(
        (resp) => {
          if (resp == null) return;

          // extract information for the avatar
          try {
            let ownerUser = resp.items[0].ownerUser;
            this.user = { name: ownerUser.name, picture: ownerUser.photoB64, role: ownerUser.role, id: ownerUser.id };
          }
          catch { // master user does not have authorizations, in that case it will end up here
            this.userService.getById(AuthService.getUserIdFromClaims()).subscribe((user) => {
              if (user == null) return;
              this.user = { name: user.name, picture: user.photoB64, role: user.role, id: user.id };
            });
          }

          // if user has authorizations then store all in menu, formating the unit to help display
          // which one is from which place
          if (resp.totalItems > 0) {
            var profilesText = this.translate.instant("HEADER.PAGE.PROFILES").toString();
            this.userMenu.push({ title: profilesText });
            this.userMenu[1].children = [];
            resp.items.forEach(auth => {
              if (auth.role != AuthRoles.visitor_company
                && auth.role != AuthRoles.visitor_residence
                && auth.role != AuthRoles.service_provider
                && auth.role != AuthRoles.visitor) {
                this.userMenu[1].children.push({
                  // regex extracts only the text between curly brackets
                  title: AuthRoles_PTBR.hasOwnProperty(auth.role) ? AuthRoles_PTBR[auth.role] : auth.role, //+ " (" + auth.unit.match(/\[(.*?)\]/)[0].replace('[','').replace(']','') + ")",
                  link: this.userMenu[1].link,
                  target: auth.role != AuthRoles.manager && auth.role != AuthRoles.operator ? auth.id.toString() : undefined
                })
              }
            });
          }
        }
      )

    this.config.get().subscribe((data: any) => {
      if (data != false) {
        let configurations: Configuration[] = data.items as Configuration[];
        configurations.forEach(c => {

          if (c.key == ConfKeys.AlertSpeeding) {
            console.log(c.value == 'true')
            if (c.value == 'true') {
              this.initSetIntervalForCheckSpeeding();
              this.getSpeedingEvents();
            } else {
              clearInterval(this.setIntervalForCheckSpeeding);
              this.alertIsOpen = false
            }
          }

          if (c.key == ConfKeys.ImgLogo) {
            if (c.value != '') {
              localStorage.setItem('imgLogo', c.value);
            } else {
              localStorage.setItem('imgLogo', '../../../assets/logo.png');
            };
          };
        });

      }
    },
      (error) => {
        console.log('error', error);
      });

    this.config.getById(1)
      .pipe(map(data => data.value))
      .subscribe((name) => {
        if (name != '') {
          this.enterpriseName = name;
        } else {
          this.enterpriseName = 'Não Licenciado';
        }
        localStorage.setItem('enterpriseName', this.enterpriseName);
      })

    localStorage.setItem('enterpriseName', this.enterpriseName);
    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

  }

  initSetIntervalForCheckSpeeding() {
    //console.log('Iniciando initSetIntervalForCheckSpeeding')
    let count = 0;
    this.setIntervalForCheckSpeeding = setInterval(() => {
      this.getSpeedingEvents();
      //console.log(count++);
    }, 300000);
  }

  getSpeedingEvents() {
    this.vehicleSpeedEventService.getSpeedingEvents().subscribe((events: any) => {
      this.speedingEvents = [];

      //console.log('Qtda de eventos de velocidade: ', events.items.length);
      if (events.items.length > 0) {
        let lsSpeedingEvents = JSON.parse(localStorage.getItem('speedingEvents'));
        this.speedingEvents = lsSpeedingEvents != null ? lsSpeedingEvents : [];

        events.items.forEach((item) => {
          let listEvent = {
            plate: item.plateId,
            speed: item.speed,
            moment: this.datepipe.transform(item.moment, 'dd/MM/yy HH:mm:ss')
          }
          this.speedingEvents.push(listEvent);
        });

        localStorage.setItem('speedingEvents', JSON.stringify(this.speedingEvents));
      } else {
        this.speedingEvents = JSON.parse(localStorage.getItem('speedingEvents'));

      }

      if (this.speedingEvents != null && this.speedingEvents.length > 0) {
        this.eventsCount = this.speedingEvents.length;
        this.alertIsOpen = true;
      };

    }, ((error) => {
      console.log('Erro ao buscar eventos de velocidade: ', error);
    }));
  };

  alertSpeedExceededClosed() {
    this.alertIsOpen = false;
    localStorage.removeItem('speedingEvents');
  }

  initSetInterval() {
    //let count = 0
    this.setInterval = setInterval(() => {
      //console.log(count ++)
      //console.log(this.setInterval)
      if (Boolean(localStorage.getItem('habilitedAdvertisement'))) {
        this.advertisement();
        localStorage.removeItem('habilitedAdvertisement')
      }
    }, this.timerSetInterval * 60000);
  }

  advertisement() {
    this.authorizationService.getAdvertisement().subscribe((responseCode) => {
      //console.log(responseCode)

    }, (error) => {
      this.statusCodeResponse = error.status
      this.showImgAdvertisement = false;

      if (this.statusCodeResponse == statusCode.lackOfPayment) {
        this.title = 'Renove sua licença'
        this.message = '';
        this.img = 'https://app.easy5.com.br/assets/images/adRenew.png';
        this.showDialogService();
      } else if (this.statusCodeResponse == statusCode.showPopup) {
        this.showImgAdvertisement = true;
        this.title = 'Adquira a versão Full'
        this.message = '';
        this.img = 'https://app.easy5.com.br/assets/images/adSign.png';
        this.showDialogService();
      } else if (this.statusCodeResponse == statusCode.logout) {
        this.title = 'Sua licença expirou'
        this.message = '';
        this.img = 'https://app.easy5.com.br/assets/images/adExpired.png';
        this.showDialogService();
      }
    })
  }

  showDialogService() {
    this.dialogService.open(PopupAdvertisementComponent, {
      closeOnBackdropClick: false,
      context: {
        title: this.title,
        message: this.message,
        img: this.img
      }
    })
      .onClose.subscribe((resp) => {
        localStorage.setItem('habilitedAdvertisement', 'true')
        if (resp === 'sign') {
          window.open("https://www.easy5.com.br", "_blank");
          this.authorizationService.contactMe().subscribe((resp) => { });
          if (this.statusCodeResponse == statusCode.logout) this.logout();
        }
        if (this.statusCodeResponse == statusCode.logout) {
          this.logout();
        }
      })
  }

  logout() {
    clearInterval(this.setInterval);
    this.authService.doLogoutUser();
  }

  ngOnDestroy() {
    clearInterval(this.setIntervalForCheckSpeeding);
    if (this.userProfileSubscription != undefined) {
      this.userProfileSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');

    return false;
  }

  navigateHome() {
    MountMenu.goToRootPage(AuthService.getUserRoleFromClaims(), this.router);
    return false;
  }
}
